module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_bgcl-neutral-800 _pst-rlt _zid-0"
  }, [_c('div', {
    staticClass: "lo-container _cl-white"
  }, [_c('div', {
    staticClass: "_pdv-32px _opct-80"
  }, [_c('div', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Made with  "), _c('i', {
    staticClass: "fa fa-heart _cl-negative u-animation-pulse"
  }), _vm._v("  by BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "_opct-50"
  }, [_vm._v("Licensed under the "), _c('a', {
    staticClass: "bio-link -white -fancy",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/blob/master/LICENSE"
    }
  }, [_vm._v("MIT License")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91b32072","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TheFooter.vue
// module id = 141
// module chunks = 0